import { LootboxLanding } from '@/components/templates/Lootbox/templates/LootboxLanding'
import { memo } from 'react'
import Layout from './layout'

const LootboxPage = () => {
  return (
    <Layout>
      <LootboxLanding />
    </Layout>
  )
}

export default memo(LootboxPage)
